





























// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { BIconFileEarmarkMinusFill } from "bootstrap-vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import config from "../config";
import router from '../router';

@Component({
  components: {},
})
export default class ConfirmEmail extends Vue {
  @Prop({default: ''}) verificationCode;
  @Prop({default: false}) verifying;
  @Prop({default: false}) submitted;
  @Prop({default: null}) errorMessage;

  resending = false;
  resendMessage: string | null = null;
  sendError: string | null = null;
  resendCooldown = 0;
  cooldownTimer: any = null;

  get loggedIn() {
    return this.$store.state.authentication.status.loggedIn;
  }

  get isSubmitted() {
    return this.submitted;
  }

  async sendVerificationCode() {
    try {
      const response: any = await axios({
        method: 'post',
        url: config.apiEndpoint + "users/send-email-verification-code",
        data: {},
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.$store.state.authentication.token,
          'x-access-token': this.$store.state.authentication.token
        },
      });

      if (!response.data.success) {
        this.sendError = response.data.msg || 'Unable to send verification code. Please try again.';
        return false;
      }

      return true;
    } catch (e) {
      this.sendError = 'Unable to send verification code. Please try again.';
      return false;
    }
  }

  startCooldown() {
    this.resendCooldown = 60;
    clearInterval(this.cooldownTimer);
    this.cooldownTimer = setInterval(() => {
      this.resendCooldown -= 1;
      if (this.resendCooldown <= 0) clearInterval(this.cooldownTimer);
    }, 1000);
  }

  async mounted() {
    const success = await this.sendVerificationCode();
    if (success) this.startCooldown();
  }

  beforeDestroy() {
    clearInterval(this.cooldownTimer);
  }

  async resendCode() {
    this.resending = true;
    this.resendMessage = null;
    this.sendError = null;

    const success = await this.sendVerificationCode();

    if (success) {
      this.resendMessage = 'A new verification code has been sent to your email.';
      this.startCooldown();
    }

    this.resending = false;
  }

  async handleSubmit (e) {
    this.submitted = true;
    this.verifying = true;
    if (this.verificationCode) {
      let response: any = await axios({
        method: 'post',
        url: config.apiEndpoint + "users/confirm-email-verification-code",
        data: {
          verificationCode: this.verificationCode
        },
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.$store.state.authentication.token,
          'x-access-token': this.$store.state.authentication.token
        },
      });

      response = response.data;

      if (response.success) {
        router.push('/client/request/list');
      }
      else {
        this.errorMessage = 'Invalid Verification Code!';
      }
    }

    this.verifying = false;
  }
}
